import { apiService } from "@/common/api.service.js";

export default {
  // User endpoints
  userList() {
    const endpoint = `/auth/user-list/`;
    return apiService(endpoint);
  },

  userInfo() {
    const endpoint = `/auth/current-user/`;
    return apiService(endpoint);
  },

  userProfile() {
    const endpoint = `/auth/profile/`;
    return apiService(endpoint);
  },

  createUserProfile() {
    const endpoint = `/auth/create-profile/`;
    return apiService(endpoint, "POST");
  },

  updateUserProfile(payload) {
    const endpoint = `/auth/profile/`;
    return apiService(endpoint, "POST", payload);
  },

  // User sites/services
  userSites() {
    const endpoint = `/auth/user-sites/`;
    return apiService(endpoint);
  },

  userServiceSites() {
    const endpoint = `/auth/user-service-sites/`;
    return apiService(endpoint);
  },

  userSiteServices() {
    const endpoint = `/auth/user-site-services/`;
    return apiService(endpoint);
  },

  // User permissions
  userPermissions(id) {
    const endpoint = `/auth/user-permissions/${id}/`;
    return apiService(endpoint);
  },

  updateSitePermissions(payload) {
    const endpoint = `/auth/update-permissions/`;
    return apiService(endpoint, "POST", payload);
  },
};
